import {A, Component, Container, createTextComponent, HR, NAV, ON_CLICK} from "@juis/components";
import type {Router} from "@juis/router";
import {createLink} from "./components/Link.js";
import {
    BUTTON_CLASS,
    BUTTONS,
    HAS_DROPDOWN,
    HAS_SHADOW,
    HAS_TEXT_WEIGHT_BOLD,
    IS_FIXED_TOP,
    IS_HOVERABLE,
    IS_LIGHT,
    IS_PRIMARY,
    IS_RIGHT,
    NAVBAR,
    NAVBAR_BRAND,
    NAVBAR_DIVIDER,
    NAVBAR_DROPDOWN,
    NAVBAR_END,
    NAVBAR_ITEM,
    NAVBAR_LINK,
    NAVBAR_MENU,
    NAVBAR_START
} from "./cssClasses.js";
import {session} from "./session.js";

const createLoginMenu = (): Container => {
    const end = new Container({cssClasses: [NAVBAR_END]});
    const item = end.appendChild(new Container({cssClasses: [NAVBAR_ITEM]}));
    const buttons = item.appendChild(new Container({cssClasses: [BUTTONS]}));
    buttons.appendChild(createLink("Sign up", "/register", BUTTON_CLASS, IS_LIGHT));
    buttons.appendChild(createLink("Log in", "/login", BUTTON_CLASS, IS_PRIMARY));
    return end;
};

const createUserMenu = (label: string): Container => {
    const end = new Container({cssClasses: [NAVBAR_END]});
    const dropdown = end.appendChild(new Container({cssClasses: [NAVBAR_ITEM, HAS_DROPDOWN, IS_HOVERABLE]}));
    dropdown.appendChild(createTextComponent(label, A, [NAVBAR_LINK]));
    const items = dropdown.appendChild(new Container({cssClasses: [NAVBAR_DROPDOWN, IS_RIGHT]}));
    items.appendChild(createLink("Settings", "/settings", NAVBAR_ITEM));
    items.appendChild(new Component({tag: HR, cssClasses: [NAVBAR_DIVIDER]}));
    const signOut = items.appendChild(createTextComponent("Log out", A, [NAVBAR_ITEM]));
    signOut.onDom(ON_CLICK, () => void session.logout().then(() => signOut.navigate("/")));
    return end;
};

/** Root of the component tree. Navigation requests bubble up to here and are handed to the router. */
export class AppShell extends Container {
    constructor(router: Router) {
        super();

        const navbar = this.appendChild(new Container({
            tag: NAV,
            cssClasses: [NAVBAR, IS_PRIMARY, IS_FIXED_TOP, HAS_SHADOW]
        }));

        const brand = navbar.appendChild(new Container({cssClasses: [NAVBAR_BRAND]}));
        brand.appendChild(createLink("Hearalong", "/", NAVBAR_ITEM, HAS_TEXT_WEIGHT_BOLD));

        const menu = navbar.appendChild(new Container({cssClasses: [NAVBAR_MENU]}));
        const start = menu.appendChild(new Container({cssClasses: [NAVBAR_START]}));
        start.appendChild(createLink("Library", "/", NAVBAR_ITEM));
        start.appendChild(createLink("Groups", "/groups", NAVBAR_ITEM));
        start.appendChild(createLink("Settings", "/settings", NAVBAR_ITEM));

        let account = menu.appendChild(createLoginMenu());
        const paintAccount = (): void => {
            const user = session.user;
            account = menu.replaceChild(user === null
                ? createLoginMenu()
                : createUserMenu(user.displayName ?? user.email), account);
        };
        paintAccount();
        session.on("change", paintAccount);

        this.appendChild(router);
        this.on("requestNavigate", request => {
            void router.navigateTo(request.url, {replace: request.replace});
        });
    }
}
